// AdminGuard: protege rutas /admin/*.
//
//   - Mientras AuthContext está rehidratando: spinner.
//   - Si no logado: redirige a /login con ?next= para volver tras éxito.
//   - Si logado pero rol != 'admin': pantalla "Sin acceso" (no redirige
//     porque podría ser un alumno que clickó sin querer un link admin).

import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, ShieldOff } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function AdminGuard({ children }) {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="admin-loading">
        <Loader2 size={28} className="spin" strokeWidth={1.5} />
        <span>{t('admin.cargando')}</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (user?.rol !== 'admin') {
    return (
      <div className="admin-sin-acceso">
        <ShieldOff size={48} strokeWidth={1.25} />
        <h1>{t('admin.sin_acceso_titulo')}</h1>
        <p>{t('admin.sin_acceso_sub')}</p>
        <a href="/" className="btn-primary">{t('admin.volver_inicio')}</a>
      </div>
    );
  }

  return children;
}
